<template>
  <div>
    <div id="formFolio" class="w-full mx-auto px-4 md:px-0">
      <!-- Forgot Form | Recovery Account -->
      <div class="flex flex-col w-full mx-auto">
        <div class="title uppercase text-center font-bold">
          {{ $t('Forms.forgot_password') }}
        </div>
        <p class="text-sm mt-3 mb-3 w-full relative text-center">
          {{ $t('Forms.forgot_password_description') }}
        </p>

        <p class="py-3">
          {{ $t('Forms.if_you_have_account') }}
          <a class="cursor-pointer text-newxcaret-blue" @click.prevent="setModalAuth(1)">
            {{ $t("Forms.login") }}
          </a>
        </p>

        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(recoveryPassword)" class="flex flex-col w-full pt-2 pb-6 relative">
            <div class="w-full relative">
              <ValidationProvider rules="required|email" v-slot="{ errors }">
                <label class="font-bold" :for="$t('Forms.email')">
                  {{ $t('Forms.email') }}
                </label>
                <input type="text" :placeholder="$t('Forms.email')" v-model="formRecoveryPass.Email"
                  :class="[errorLogin.email && 'is-invalid']" :id="$t('Forms.email')" :name="$t('Forms.email')" class="
                  w-full
                  h-10
                  p-3
                  my-2
                  border border-newxcaret-blue
                  bg-white
                  rounded-lg
                " />
                <p class="txt-error text-red text-xs italic">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
              <ul class="emailsCommonList">
                <li class="px-3 py-2 cursor-pointer" v-for="email in emailsCommonList" :key="email" v-html="email"
                  @click.prevent="setValuesToEmail(email)"></li>
              </ul>
              <p class="txt-error text-red text-xs italic" v-if="errorLogin.email">
                {{ responseErrors.Email[0] }}
              </p>
            </div>

            <div class="flex flex-col md:flex-row items-center">
              <a :title="$t('Forms.i_have_code')" class="cursor-pointer text-newxcaret-blue w-full md:w-3/5"
                @click.prevent="setModalAuth(5)">
                {{ $t('Forms.i_have_code') }}
              </a>

              <button type="submit" class="
                  flex
                  w-full
                  md:w-2/5
                  items-center
                  justify-center
                  w-full
                  mt-4
                  md:mx-2 md:my-auto
                  p-2
                  bg-yellow-photo
                  rounded-full
                  text-sm
                  font-semibold
                ">
                {{ $t('Forms.send') }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import "@validators/index";
import methodUser from "@mixins/methodUser";

//Mixins
import Users from "@mixins/Users";
import Helper from "@mixins/helper";

import SearchPackage from "@components/photo/searchPackageComponent";
import loginData from "@logic/profile/login";
import registerData from "@logic/profile/register";
import activateNewUserData from "@logic/profile/activateNewUser";
import recoveryPasswordData from "@logic/profile/recoveryPassword";
import validatePasswordData from "@logic/profile/validatePassword";

export default {
  props: [],
  mixins: [methodUser, Users, Helper],
  components: {
    SearchPackage,
  },
  data: () => ({
    user: {},
    pathname: window.location.origin + "/",
    BirthdateInput: { name: "Birthdate" },
    loading: false,
    formLogin: {
      Username: "",
      Password: "",
    },
    formRegister: {
      Password: "", //*
      Email: "", //example@email.com
      FirstName: "", //test
      LastName: "", //test
      Phone: "",
      Birthdate: "", //31/12/1982
      Locale: "", //Mexico
      Gender: "", //Masculino
      Title: "", //Sr.
    },
    formActiveNewUser: {
      Email: "", //example@email.com
      Code: "",
      helperBtnSend: true,
    },
    formResetPassword: {
      Email: "", //example@email.com
      Code: "",
      Password: "",
      helperBtnSend: true,
    },
    formRecoveryPass: {
      Email: "",
    },
  }),
  watch: {
    activeForm: function () {
      this.errorLogin.statusApiMessage = false;
      this.msgApi.success = false;
      this.msgApi.error = false;
      this.disableAllInputs();
    },
    'formRecoveryPass.Email': function (val) {
      this.setValueWatchEmail(val);
    }
  },
  computed: {
    // Acceder al state de 'auth' module
    ...mapState('auth', ['modalAuth', 'user']),

    // Usar getters de 'auth' module
    ...mapGetters('auth', ['getModalAuth', 'getUser', 'getEmailsCommon']),
  },
  methods: {
    // Usar acciones de 'auth' module
    ...mapActions('auth', ['setModalAuth', 'setUser']),
    async login() {
      try {
        this.loading = true;
        // POST request using axios
        let response = await loginData.get(this.formLogin);

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error de validacion de campos
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(() => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.username = false;
          this.errorLogin.password = false;

          if (this.errorFormInput(response.data, "ACCESS")) {
            this.activeForm = response.data.ACCESS == true ? 3 : 0;
            this.setUserLoggedIn(response.data.ACCESS == true ? true : false);
          } else {
            if (
              this.errorFormInput(response.data, "SUCCESS") &&
              this.errorFormInput(response.data, "MESSAGE")
            ) {
              if (response.data.SUCCESS == "false") {
                this.msgApi.error = true;
                this.msgApi.message = response.data.MESSAGE;
              }
            }
          }
        }
        //se settea el loadign para desaactivarlo
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async register() {
      try {
        // POST request using axios
        let response = await registerData.create(this.formRegister);
        this.loading = true;
        this.errorLogin.statusApiMessage = false;

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(() => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.email = false;
          this.errorLogin.password = false;
          this.errorLogin.birthdate = false;

          if (this.errorFormInput(response.data, "SUCCESS")) {
            if (this.errorFormInput(response.data, "SUCCESS")) {
              if (response.data.SUCCESS == "true") {
                this.msgApi.error = false;
                this.msgApi.success = true;
                this.activeForm = 4;
                this.formActiveNewUser.Email = this.formRegister.Email;
              } else {
                this.msgApi.error = false;
                this.msgApi.error = true;
              }
              this.msgApi.message = response.data.MESSAGE;
            }
          }
        }
        //se settea el loadign para desaactivarlo
        this.loading = false;
      } catch (error) {
        //se settea el loadign para desaactivarlo
        this.loading = false;
        
      }
    },
    async activateNewUser() {
      try {
        this.loading = true;
        this.errorLogin.statusApiMessage = false;
        // POST request using axios
        let response = await activateNewUserData.create(this.formActiveNewUser);

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(() => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.email = false;
          this.errorLogin.Code = false;
          // this.errorLogin.birthdate = false;

          if (this.errorFormInput(response.data, "SUCCESS")) {
            if (this.errorFormInput(response.data, "SUCCESS")) {
              if (response.data.SUCCESS == "true") {
                this.msgApi.error = false;
                this.msgApi.success = true;

                this.activeForm = 0;

                this.makeToast("success", "¡Tu cuenta ha sido activada!");
              } else {
                this.msgApi.success = false;
                this.msgApi.error = true;
              }
              this.msgApi.message = response.data.MESSAGE;
              
              
            }
          }
        }
        //se settea el loadign para desaactivarlo
        this.loading = false;
      } catch (error) {
        //se settea el loadign para desaactivarlo
        this.loading = false;
        
      }
    },
    async recoveryPassword() {
      try {
        // POST request using axios
        let response = await recoveryPasswordData.create(this.formRecoveryPass);
        this.loading = true;
        this.errorLogin.statusApiMessage = false;

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(() => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.email = false;
          if (this.errorFormInput(response.data, "SUCCESS")) {
            if (response.data.SUCCESS == "true") {
              this.msgApi.error = false;
              this.msgApi.success = true;
              this.$router.push({ name: "recover" });
            } else {
              this.msgApi.error = false;
              this.msgApi.error = true;
            }
            this.msgApi.message = response.data.MESSAGE;
          }
        }
        //se settea el loadign para desaactivarlo
        this.loading = false;
      } catch (error) {
        
        //se settea el loadign para desaactivarlo
        this.loading = false;
      }
    },
    async validatePassword(valuePassword) {
      try {
        // POST request using axios
        let response = await validatePasswordData.get({
          Password: valuePassword,
        });
        this.formActiveNewUser.helperBtnSend = true;
        this.responseErrors = response.data;

        Object.entries(this.responseErrors).forEach(() => {
          this.validFieldsRegister(this.responseErrors);
        });

        if (!response.data.count) {
          this.errorLogin.password = false;
          this.formActiveNewUser.helperBtnSend = false;
          this.formResetPassword.helperBtnSend = false;
        } else {
          this.errorLogin.password = true;
          this.formActiveNewUser.helperBtnSend = true;
          this.formResetPassword.helperBtnSend = true;
        }
      } catch (error) {
        
      }
    },
    /**
         * Método para validar los campos del formulario de registro
         * @param {email} email
         */
    setValuesToEmail(email = "") {
      if (email != "") {
        this.formRecoveryPass.Email = email;
      }
      this.emailsCommonList = [];
      this.flatSelectEmail = true;
    }
  },
  mounted() {
    this.formRecoveryPass.Email = this.getUser?.Email;
  },
};
</script>